<template>
  <div>
    <AppHeader/>

    <v-container class="global-margin pb-0 mb-0 pt-8">
      <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
    </v-container>

    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" md="3">
          <v-img v-if="$route.params.alias === '2019'" :src="require('@/assets/img/prdays-logo-old.png')" contain height="150"></v-img>
          <v-img v-else-if="$route.params.alias === '2020'" :src="require('@/assets/img/prdays-logo.svg')" contain height="150"></v-img>
          <v-img v-else-if="$route.params.alias === '2021'" :src="require('@/assets/img/prdays-logo-black.svg')" contain height="150"></v-img>
          <v-img v-else-if="$route.params.alias === '2022'" :src="require('@/assets/img/logo_prdays_2022.svg')" contain height="150"></v-img>
          <v-img v-else-if="$route.params.alias === '2023'" :src="require('@/assets/2023/prdays-logo-2023.svg')" contain height="150"></v-img>
          <v-img v-else-if="$route.params.alias === '2024'" :src="require('@/assets/2023/prdays-logo-2023.svg')" contain height="150"></v-img>
          <v-img v-else-if="$route.params.alias === '2025'" :src="require('@/assets/2023/prdays-logo-2023.svg')" contain height="150"></v-img>

        </v-col>
        <v-col cols="12" md="10" >
          <div v-if="$route.params.alias === '2019'">{{$t('fourth_text')}}</div>
          <div v-else-if="$route.params.alias === '2020'">{{$t('fifth_text')}}</div>
          <div v-else-if="$route.params.alias === '2021'">{{$t('sixth_text')}}</div>
          <div v-else-if="$route.params.alias === '2022'">{{$t('seventh_text')}}</div>
          <div v-else-if="$route.params.alias === '2023'" v-html="$t('eighth_text_full_text')"></div>
          <div v-else-if="$route.params.alias === '2024'" v-html="$t('ninth_text_full_text')"></div>
          <div v-else-if="$route.params.alias === '2025'" v-html="$t('tenth_text_full_text')"></div>
        </v-col>
      </v-row>
    </v-container>

    <v-container id="predavaci" grid-list-lg class="pt-5 mt-5" v-if="predavaci.length">
      <v-row>
        <v-col cols="12">
          <h1 class="font">
            {{$t('predavaci')}}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4" xs="12" v-for="(item, i) in predavaci" :key="i">
          <v-lazy
              v-model="isActive"
              :options="{
              threshold: .5
            }"
              min-height="200"
              transition="fade-transition"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card class="mx-auto" color="grey lighten-4" max-width="600">
                <v-img height="100%" :aspect-ratio="1" :src="item.img">
                  <v-expand-transition>
                    <div
                        v-if="hover"
                        class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-1 white--text font"
                        style="height: 100%;"
                    >{{ item.name }}
                    </div>
                  </v-expand-transition>
                </v-img>
                <v-card-text class="pt-6" style="position: relative;">
                  <!-- <v-btn
                  absolute
                  color="black"
                  class="white--text"
                  fab
                  large
                  right
                  top
                  @click="Show(i)"
                >
                  <v-icon>fas fa-plus</v-icon>
                  </v-btn>-->
                  <h4 class="title font-weight-light mb-2 font" style="color: black">
                    <b>{{ item.name }}</b>
                  </h4>
                  <div
                      class="font-weight-light body mb-2"
                      style="color: black"
                      v-if="show == i"
                  >{{ item.about }}
                  </div>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-lazy>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AppHeader from './AppHeader';

export default {
  name: "Arhiva",
  components: {AppHeader},
  mounted() {
    window.scrollTo(0, 0);
    if(this.$route.params.alias === '2019') {
      this.predavaci = this.predavaci_2019
      this.breadcrumbs.push({
        text: '2019',
        disabled: true,
      },)
    }
    else if(this.$route.params.alias === '2020'){
      this.predavaci = this.predavaci_2020
      this.breadcrumbs.push({
        text: '2020',
        disabled: true,
      },)
    }
    else if(this.$route.params.alias === '2021'){
      this.predavaci = this.predavaci_2021
      this.breadcrumbs.push({
        text: '2021',
        disabled: true,
      },)
    }
    else if(this.$route.params.alias === '2022'){
      this.breadcrumbs.push({
        text: '2022',
        disabled: true,
      },)
    }
    else if(this.$route.params.alias === '2023'){
      this.breadcrumbs.push({
        text: '2023',
        disabled: true,
      },)
    }
    else if(this.$route.params.alias === '2024'){
      this.breadcrumbs.push({
        text: '2024',
        disabled: true,
      },)
    }
    else if(this.$route.params.alias === '2025'){
      this.breadcrumbs.push({
        text: '2025',
        disabled: true,
      },)
    }
  },
  methods: {
    onScroll() {
      this.isScrolling =
          (window.pageYOffset || document.documentElement.scrollTop || 0) > 100;
    },
  },
  data: () => ({
    isActive: false,
    isScrolling: false,
    breadcrumbs: [
      {
        text: 'Naslovnica',
        disabled: false,
        to: '/'
      },
      {
        text: 'Arhiva',
        disabled: true,
      },
    ],
    predavaci: [],
    predavaci_2019: [
      {
        name: "Zoran Tomić",
        img: require("@/assets/img/rektor1.jpg"),
        about: ""
      },
      {
        name: "Damir Jugo",
        img: require("@/assets/img/damir_jugo1.jpg"),
        about: ""
      },
      {
        name: "W. Timothy Coombs",
        img: require("@/assets/img/coombs.jpg"),
        about: ""
      },
      {
        name: "Božidar Novak",
        img: require("@/assets/img/bozidar_novak.jpg"),
        about: ""
      },
      {
        name: "Emilija Rabrenović",
        img: require("@/assets/img/emilija.jpeg"),
        about: ""
      },
      {
        name: "Milica Kostić Stanković",
        img: require("@/assets/img/milica.jpg"),
        about: ""
      },
      {
        name: "Sanja Bijakšić",
        img: require("@/assets/img/sanja_bijaksic.jpg"),
        about: ""
      },
      {
        name: "Nenad Brkić",
        img: require("@/assets/img/nenad_brkic.jpg"),
        about: ""
      },
      {
        name: "Semina Ajvaz",
        img: require("@/assets/img/sabina.jpg"),
        about: ""
      },
      {
        name: "Gordana Lesinger",
        img: require("@/assets/img/lesinger.jpg"),
        about: ""
      },
      {
        name: "Ilija Musa",
        img: require("@/assets/img/ilija.jpg"),
        about: ""
      },
      {
        name: "Dušan Stojaković",
        img: require("@/assets/img/dusan.jpg"),
        about: ""
      },
      {
        name: "Dragana Todorović",
        img: require("@/assets/img/dragan.jpg"),
        about: ""
      },
      {
        name: "Dragan Babić",
        img: require("@/assets/img/dragan_babic.jpg"),
        about: ""
      },
      {
        name: "Danijel Labaš",
        img: require("@/assets/img/danijellabas.jpg"),
        about: ""
      },
      {
        name: "Smiljana Leinert Novosel",
        img: require("@/assets/img/smiljana.jpg"),
        about: ""
      },
      {
        name: "Aleksandar Bogdanić",
        img: require("@/assets/img/bogdanic.jpg"),
        about: ""
      },
      {
        name: "Siniša Kovačić",
        img: require("@/assets/img/sinisa.jpg"),
        about: ""
      },
      {
        name: "Ivana Ivančić",
        img: require("@/assets/img/ivana.jpg"),
        about: ""
      },
      {
        name: "Bojan Hadžihalilović",
        img: require("@/assets/img/bojan.jpg"),
        about: ""
      },
      {
        name: "Damir Dobrinić",
        img: require("@/assets/img/damir.jpg"),
        about: ""
      },
      {
        name: "Miloš Šolaja",
        img: require("@/assets/img/milos.jpg"),
        about: ""
      },
      {
        name: "Vedran Peršić",
        img: require("@/assets/img/vedran.jpg"),
        about: ""
      },
      {
        name: "Boban Tomić",
        img: require("@/assets/img/boban.jpg"),
        about: ""
      },
      {
        name: "Arnela Bevanda",
        img: require("@/assets/img/arnela.jpg"),
        about: ""
      },
      {
        name: "Đorđe Obradović",
        img: require("@/assets/img/obradovic.jpg"),
        about: ""
      },
      {
        name: "Miro Radalj",
        img: require("@/assets/img/radalj.jpg"),
        about: ""
      },
      {
        name: "Mario Lukinović",
        img: require("@/assets/img/lukinovic.jpg"),
        about: ""
      },
      {
        name: "Sandra Karabatić",
        img: require("@/assets/img/sandra.jpeg"),
        about: ""
      },
      {
        name: "Anita Jeličić",
        img: require("@/assets/img/jelicic.jpg"),
        about: ""
      }
    ],
    predavaci_2020: [
      {
        name: "Zoran Tomić",
        img: require("@/assets/img/zoran_tomic.png"),
        about: ""
      },
      {
        name: "Damir Jugo",
        img: require("@/assets/img/damir_jugo.png"),
        about: ""
      },
      {
        name: "Milica Kostić Stanković",
        img: require("@/assets/img/milica_kostic.png"),
        about: ""
      },
      {
        name: "Sanja Bijakšić",
        img: require("@/assets/img/sanja_bijaksic.png"),
        about: ""
      },
      {
        name: "Siniša Kovačić",
        img: require("@/assets/img/sinisa_kovacic.png"),
        about: ""
      },
      {
        name: "Đorđe Obradović",
        img: require("@/assets/img/dorde_obradovic.png"),
        about: ""
      },
      {
        name: "Al Ghurair",
        img: require("@/assets/img/al_ghuair.png"),
        about: ""
      },
      {
        name: "Božo Skoko",
        img: require("@/assets/img/bozo_skoko.png"),
        about: ""
      },
      {
        name: "Franjo Takač",
        img: require("@/assets/img/franjo_takac.png"),
        about: ""
      },
      {
        name: "Nasiha Osmanovic",
        img: require("@/assets/img/nasiha_osmanovic.png"),
        about: ""
      },
      {
        name: "Olivera Popović",
        img: require("@/assets/img/olivera_popovic.png"),
        about: ""
      }
    ],
    predavaci_2021: [
      {
        name: "Božo Skoko",
        img: require("@/assets/predavaci_2021/1.png"),
        about: ""
      },
      {
        name: "Danijel Labaš",
        img: require("@/assets/predavaci_2021/2.png"),
        about: ""
      },
      {
        name: "Đorđe Obradović",
        img: require("@/assets/predavaci_2021/3.png"),
        about: ""
      },
      {
        name: "Sarina Bakić",
        img: require("@/assets/predavaci_2021/4.png"),
        about: ""
      },
      {
        name: "Zoran Tomić",
        img: require("@/assets/predavaci_2021/5.png"),
        about: ""
      },
      {
        name: "Simon Chadwick",
        img: require("@/assets/predavaci_2021/6.png"),
        about: ""
      },
      {
        name: "Marijan Primorac",
        img: require("@/assets/predavaci_2021/7.png"),
        about: ""
      },
      {
        name: "Mike Baker",
        img: require("@/assets/predavaci_2021/8.png"),
        about: ""
      },
      {
        name: "Sarah McAdam",
        img: require("@/assets/predavaci_2021/9.png"),
        about: ""
      },
      {
        name: "John Deane O'Keeffee",
        img: require("@/assets/predavaci_2021/10.png"),
        about: ""
      },
      {
        name: "Marcel Danesi",
        img: require("@/assets/predavaci_2021/11.png"),
        about: ""
      },
      {
        name: "Joseph Favorito",
        img: require("@/assets/predavaci_2021/12.png"),
        about: ""
      },
      {
        name: "Franjo Takač",
        img: require("@/assets/predavaci_2021/13.png"),
        about: ""
      },
      {
        name: "Azra Isić",
        img: require("@/assets/predavaci_2021/14.png"),
        about: ""
      },
      {
        name: "Vladimir Novaković",
        img: require("@/assets/predavaci_2021/15.png"),
        about: ""
      },
      {
        name: "Zdravko Reić",
        img: require("@/assets/predavaci_2021/16.png"),
        about: ""
      },
      {
        name: "Ivan Tomić",
        img: require("@/assets/predavaci_2021/17.png"),
        about: ""
      },
      {
        name: "Davor Pavić",
        img: require("@/assets/predavaci_2021/18.png"),
        about: ""
      },
    ]
  })
}
</script>

<style lang="scss" scoped>
.v-tabs-bar__content {
  background-color: #fafafa !important;
}

.card_bg1 {
  background-image: linear-gradient(310deg, #464646, #757575);
}

.card_bg2 {
  background-image: linear-gradient(310deg, #1b1b1b, #5e5e5e);
}

.card_bg3 {
  background-image: linear-gradient(310deg, #000000, #474747);
}

.bg {
  background-image: linear-gradient(310deg, #000000, #5a5a5a);
  padding: 0;
  position: relative;
  color: #fff;
}

.bg .oblak {
  width: 100%;
  height: 200px;
  position: absolute;
  bottom: 0;
  left: 0 !important;
}

.bg .oblak-xs {
  width: 100%;
  height: 100px;
  position: absolute;
  bottom: 0;
  left: 0 !important;
}

.img {
  width: 50%;
  height: 150px;
  top: 60px;
  padding-left: 50px;
  position: relative;

  -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 3s; /* Safari 4.0 - 8.0 */
  animation-name: example;
  animation-duration: 3s;
}

.img1 {
  margin-top: -200px;
  width: 42%;
  height: 150px;
  top: 500px;
  padding-left: 50px;
  position: relative;

  -webkit-animation-name: example1; /* Safari 4.0 - 8.0 */
  -webkit-animation-duration: 2s; /* Safari 4.0 - 8.0 */
  animation-name: example1;
  animation-duration: 2s;
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes example {
  0% {
    top: 60px;
    left: -750px;
    margin-left: -200px;
  }
  50% {
    top: 60px;
    left: -750px;
    margin-left: -200px;
  }
  100% {
    top: 60px;
    left: 0px;
    margin-left: 0px;
  }
}

/* Standard syntax */
@keyframes example {
  0% {
    top: 60px;
    left: -750px;
    margin-left: -200px;
  }
  50% {
    top: 60px;
    left: -750px;
    margin-left: -200px;
  }
  100% {
    top: 60px;
    left: 0px;
    margin-left: 0px;
  }
}

@-webkit-keyframes example1 {
  0% {
    margin-top: -200px;
    top: 500px;
    left: -750px;
    margin-left: -200px;
  }
  50% {
    margin-top: -200px;
    top: 500px;
    left: -750px;
    margin-left: -200px;
  }
  100% {
    margin-top: -200px;
    top: 500px;
    left: 0px;
    margin-left: 0px;
  }
}

/* Standard syntax */
@keyframes example1 {
  0% {
    margin-top: -200px;
    top: 500px;
    left: -750px;
    margin-left: -200px;
  }
  50% {
    margin-top: -200px;
    top: 500px;
    left: -750px;
    margin-left: -200px;
  }
  100% {
    margin-top: -200px;
    top: 500px;
    left: 0px;
    margin-left: 0px;
  }
}

.nav-act:hover,
.nav-act:active {
  background-color: transparent;
  border-bottom: 5px solid white;
  font-weight: bold;
}

.nav-act {
  text-decoration: none;
  display: block;
  text-align: center;
  float: left;
  border-bottom: 5px solid transparent;
}

.nav-act-blck:hover,
.nav-act-blck:active {
  background-color: transparent;
  border-bottom: 5px solid #ED1B34;
  font-weight: bold;
}

.nav-act-blck {
  text-decoration: none;
  display: block;
  text-align: center;
  float: left;
  border-bottom: 5px solid transparent;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.img-saturation {
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
.img-saturation:hover {
  transition-duration: 0.6s;
  -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
  filter: grayscale(0%);
}

//.font {
//  font-family: Baloo;
//}
.font {
  font-family: "Helvetica Neue";
}


.fix-btn {
  position: fixed;
  bottom: 60px;
  right: 40px;
  z-index: 999;
}

.theme--light.v-tabs-items {
  background-color: #fafafa !important;
}
.flip-clock {
  text-align: center;
  perspective: 600px;
  margin: 0 auto;

  *,
  *:before,
  *:after { box-sizing: border-box; }
}

.flip-clock__piece {
  display: inline-block;
  margin: 0 0.2vw;

  @media (min-width: 1000px) {
    margin: 0 5px;
  }
}

.flip-clock__slot {
  font-size: 1rem;
  line-height: 1.5;
  display: block;
  /*
    //position: relative;
    //top: -1.6em;
    z-index: 10;
    //color: #FFF;
  */
}



.flip-card {
  display: block;
  position: relative;
  padding-bottom: 0.72em;
  font-size: 2.25rem;
  line-height: 0.95;
}

@media (min-width: 1000px) {
  .flip-clock__slot { font-size: 1.2rem; }
  .flip-card { font-size: 3rem; }
}


/*////////////////////////////////////////*/


.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  display: block;
  height: 0.72em;
  color: #ccc;
  background: #222;
  padding: 0.23em 0.25em 0.4em;
  border-radius: 0.15em 0.15em 0 0;
  backface-visiblity: hidden;
  transform-style: preserve-3d;
  width: 1.8em;
}

.flip-card__bottom,
.flip-card__back-bottom {
  color: #FFF;
  position: absolute;
  top: 50%;
  left: 0;
  border-top: solid 1px #000;
  background: #393939;
  border-radius: 0 0 0.15em 0.15em;
  pointer-events: none;
  overflow: hidden;
  z-index: 2;
}

.flip-card__back-bottom {
  z-index: 1;
}

.flip-card__bottom::after,
.flip-card__back-bottom::after {
  display: block;
  margin-top: -0.72em;
}

.flip-card__back::before,
.flip-card__bottom::after,
.flip-card__back-bottom::after {
  content: attr(data-value);
}

.flip-card__back {
  position: absolute;
  top: 0;
  height: 100%;
  left: 0%;
  pointer-events: none;
}

.flip-card__back::before {
  position: relative;
  overflow: hidden;
  z-index: -1;
}

.flip .flip-card__back::before {
  z-index: 1;
  animation: flipTop 0.3s cubic-bezier(.37,.01,.94,.35);
  animation-fill-mode: both;
  transform-origin: center bottom;
}

.flip .flip-card__bottom {
  transform-origin: center top;
  animation-fill-mode: both;
  animation: flipBottom 0.6s cubic-bezier(.15,.45,.28,1);// 0.3s;
}

@keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 2;
  }
  0%, 99% {
    opacity: 1;
  }
  100% {
    transform: rotateX(-90deg);
    opacity: 0;
  }
}

@keyframes flipBottom {
  0%, 50% {
    z-index: -1;
    transform: rotateX(90deg);
    opacity: 0;
  }
  51% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: rotateX(0deg);
    z-index: 5;
  }
}

.article-card {
  min-height: 250px;
  width: 100%;
  overflow: hidden;
  .article-img-wrap {
    display: inline-block;
    overflow: hidden;
    height: 280px;
    .article-img {
      transition: transform 0.4s;
      height: 100%;
    }
  }
  &:hover {
    .article-img {
      transform: scale(1.1);
      transform-origin: 50% 50%;
    }
  }
}
</style>